
const skillsData = [
    {
        technology: 'Azure Sentinel',
        image: '/Azure Sentinel.png'
    },
    {
        technology: 'SOC Analyst',
        image: '/socanalyst.png'
    },
    {
        technology: 'IDS and IPS',
        image: '/idsips.png'
    },
    {
        technology: 'Firewall',
        image: '/firewall.png'
    },
    {
        technology: 'Splunk SIEM',
        image: '/splunk.png'
    },
    {
        technology: 'Networking',
        image: '/Networking.png'
    },
    {
        technology: 'HTML5',
        image: '/HTML5.png'
    },
    {
        technology: 'CSS3',
        image: '/CSS3.png'
    },
    {
        technology: 'JavaScript',
        image: '/JS.png'
    },
    {
        technology: 'MongoDB',
        image: '/MongoDB.png'
    },
    {
        technology: 'Express.js',
        image: '/ExpressJS.png'
    },
    {
        technology: 'React.js',
        image: '/ReactJS.png'
    },
    {
        technology: 'Node.js',
        image: '/NodeJS.png'
    },
    {
        technology: 'Tailwind CSS',
        image: '/Tailwind CSS.png'
    },
    {
        technology: 'Git',
        image: '/Git.png'
    },
    {
        technology: 'Bootstrap 5',
        image: '/Bootstrap.webp'
    },
    {
        technology: 'Firebase',
        image: '/Firebase.png'
    },
];

export default skillsData;
